import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import type { Blog } from '../types/Blog';

interface BlogCardProps {
  blog: Blog;
}

const BlogCard: React.FC<BlogCardProps> = ({ blog }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(`/blogs/${blog.id}`);
  };

  return (
    <Link to={`/blogs/${blog.id}`} onClick={handleClick}>
      <article className="dev-card block p-6">
        <h3 className="text-2xl font-medium mb-2 text-dev-text">{blog.title}</h3>
        <div className="text-dev-text-muted mb-2 flex items-center gap-1">
          <span>{blog.date}</span>
          <span className="mx-1">·</span>
          <span>{blog.readTime}</span>
        </div>
        <p className="text-dev-text-muted text-lg mb-3">{blog.description}</p>
        <div className="flex flex-wrap gap-2">
          {blog.tags.map((tag, index) => (
            <span key={index} className="tech-badge">
              {tag}
            </span>
          ))}
        </div>
      </article>
    </Link>
  );
};

export default BlogCard; 